/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Fast_Heron_LickInputs */

const en_clear_fast_heron_lick = /** @type {(inputs: Clear_Fast_Heron_LickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select file`)
};

const de_clear_fast_heron_lick = /** @type {(inputs: Clear_Fast_Heron_LickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei auswählen`)
};

/**
* | output |
* | --- |
* | "Select file" |
*
* @param {Clear_Fast_Heron_LickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_fast_heron_lick = /** @type {((inputs?: Clear_Fast_Heron_LickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Fast_Heron_LickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear_fast_heron_lick(inputs)
	return de_clear_fast_heron_lick(inputs)
});